
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Busrentalsfortourpackage() {



    const cardData =
    {
        keyword: 'Bus Rental for Tour Packages',
        heading: 'Amruta Travels: Bus Rental for Tour Packages',
        headingDescription: 'Amruta Travels offers Bus Rental for Tour Packages in Pune, providing comfortable, reliable, and customizable transportation solutions for all your travel needs. Whether you are planning a spiritual pilgrimage, a family vacation, or a group tour, our well-maintained fleet ensures a smooth and enjoyable journey. With experienced drivers, punctual service, competitive pricing, and 24/7 support, we make your tour experience hassle-free and memorable. Choose from our range of buses, including 32-seater, 35-seater, 45-seater, and 50-seater options, to suit your group size. Book your tour package bus with Amruta Travels and explore your destinations in comfort and style!',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],

     "services": [
    {
      "name": "Bus Rental for Tour Package Pune to Lonavala",
      "description": "Explore the scenic beauty of Lonavala with Amruta Travels’ bus rental service. Whether it's a family outing, a corporate trip, or a sightseeing tour, our buses provide a comfortable, safe, and affordable ride. Enjoy a smooth journey to this popular hill station near Pune with flexible schedules and experienced drivers."
    },
    {
      "name": "Bus Rental for Tour Packages for Pune Lavasa City",
      "description": "Plan a memorable trip to Lavasa City with Amruta Travels. Our bus rentals offer the best way to travel from Pune to Lavasa, whether for a corporate outing or a group tour. With options for both AC and non-AC buses, we ensure a comfortable and enjoyable journey to this beautiful man-made hill station."
    },
    {
      "name": "Bus Rental for Tour Package Pune to Mumbai",
      "description": "Make your journey from Pune to Mumbai hassle-free with Amruta Travels’ bus rental service. Our buses are equipped with modern amenities, offering a comfortable and relaxing ride. Ideal for family trips, corporate outings, and group tours, we provide both AC and non-AC buses for your convenience."
    },
    {
      "name": "Bus Rental for Tour Package Pune to Nashik",
      "description": "Amruta Travels provides convenient bus rental services for a tour package from Pune to Nashik. Whether you’re planning a pilgrimage, a wine tour, or a family getaway, our fleet of well-maintained buses ensures a smooth and comfortable ride to this spiritual city known for its temples and vineyards."
    },
    {
      "name": "Bus on Rent for Pune to Tuljapur",
      "description": "Embark on a spiritual journey to Tuljapur with Amruta Travels’ bus rental service. Our buses offer comfortable and safe transportation for groups visiting the famous Tulja Bhavani Temple. Whether for religious purposes or a group tour, our buses cater to your needs with professional drivers and timely service."
    },
    {
      "name": "Bus on Rent for Pune to Pandharpur",
      "description": "Make your pilgrimage to Pandharpur comfortable with Amruta Travels. We offer buses on rent for group travel from Pune to Pandharpur, ensuring safe and timely arrival for all pilgrims. Our fleet of buses comes with professional chauffeurs and flexible travel schedules to meet your religious tour requirements."
    },
    {
      "name": "AC/Non-AC Bus for Outstation",
      "description": "Travel in comfort with Amruta Travels’ AC and non-AC buses for outstation trips. Whether it's a short getaway or a long-distance journey, our buses are perfect for groups of any size, providing a relaxing and enjoyable ride to any destination from Pune."
    },
    {
      "name": "Bus Rental for Corporate Events in Pune",
      "description": "Amruta Travels offers reliable bus rental services for corporate events in Pune. Whether it’s an office outing, a seminar, or a business trip, our buses are equipped with modern amenities, ensuring comfort and punctuality for all attendees. Choose from a variety of buses to fit your event needs."
    },
    {
      "name": "Bus Rental for Ashtavinayak Tour from Pune",
      "description": "Embark on a spiritual journey with Amruta Travels' Ashtavinayak Darshan bus rental service. Our buses are ideal for groups visiting the eight sacred Ganesh temples around Pune. With experienced drivers and a fleet of well-maintained buses, we provide a smooth, comfortable, and spiritually uplifting experience."
    },
    {
      "name": "Bus Hire for Jyotirlinga Darshan From Pune",
      "description": "Visit the sacred Jyotirlingas with Amruta Travels' bus rental services. We offer comfortable buses for group tours to all the 12 Jyotirlingas from Pune. Our services ensure a smooth, safe, and timely journey, with flexible schedules and expert drivers to guide your pilgrimage."
    },
    {
      "name": "Mini Bus on Rent in Pune",
      "description": "If you need a smaller vehicle for a short trip or a small group, Amruta Travels offers mini bus rentals in Pune. Our mini buses are perfect for local tours, corporate outings, or small family trips, providing comfort and reliability at affordable rates."
    },
    {
      "name": "AC 17 Seater Bus on Rent in Pune",
      "description": "Rent an AC 17-seater bus from Amruta Travels for your next group outing or event. Perfect for small groups, this bus offers comfort, air conditioning, and ample space for passengers. Whether it's a short trip or a longer journey, our 17-seater buses are ideal for family outings, corporate events, or school trips."
    }
  ],
  "tableData": [
    ["Bus Rental for Tour Package Pune to Lonavala", "Bus Rental for Tour Packages for Pune Lavasa City"],
    ["Bus Rental for Tour Package Pune to Mumbai", "Bus Rental for Tour Package Pune to Nashik"],
    ["Bus on Rent for Pune to Tuljapur", "Bus on Rent for Pune to Pandharpur"],
    ["AC/Non-AC Bus for Outstation", "Bus Rental for Corporate Events in Pune"],
    ["Bus Rental for Ashtavinayak Tour from Pune", "Bus Hire for Jyotirlinga Darshan From Pune"],
    ["Mini Bus on Rent in Pune", "AC 17 Seater Bus on Rent in Pune"]
  ],




"whychoose": [
  {
    "WhyChooseheading": "Convenient Group Transportation",
    "WhyChoosedescription": "Amruta Travels offers Bus on Rent for Event in Pune, providing smooth and efficient transport for all types of events—corporate, social, cultural, or private gatherings."
  },
  {
    "WhyChooseheading": "Ideal for All Event Types",
    "WhyChoosedescription": "Whether it’s a conference, exhibition, concert, or family celebration, our buses are perfect for transporting guests or participants to and from the venue comfortably and on time."
  },
  {
    "WhyChooseheading": "Experienced and Courteous Drivers",
    "WhyChoosedescription": "Our trained drivers are punctual, professional, and familiar with major event venues across Pune, ensuring a reliable and hassle-free experience for all passengers."
  },
  {
    "WhyChooseheading": "Transparent and Affordable Pricing",
    "WhyChoosedescription": "We provide budget-friendly bus rental services for events with clear, upfront pricing and no hidden costs—making event transportation easy to manage."
  },
  {
    "WhyChooseheading": "Clean, Air-Conditioned Buses",
    "WhyChoosedescription": "Our fleet of well-maintained buses offers clean interiors, comfortable seating, and air conditioning to ensure your guests travel in comfort and style."
  },
  {
    "WhyChooseheading": "Flexible Scheduling and Custom Routes",
    "WhyChoosedescription": "We offer flexible pickup/drop-off times and fully customizable routes to accommodate your event schedule and logistics seamlessly."
  },
  {
    "WhyChooseheading": "Fleet for All Group Sizes",
    "WhyChoosedescription": "From small VIP groups to large audiences, we provide various bus sizes—from 20 to 50 seaters—so you get exactly what your event requires."
  },
  {
    "WhyChooseheading": "Easy Booking and Full Support",
    "WhyChoosedescription": "Booking a Bus on Rent for Event in Pune is simple with Amruta Travels. Our responsive team helps with booking, scheduling, and coordination every step of the way."
  }
]




























    }

const faqData = [
  {
    question: 'How can I rent a bus for a tour package with Amruta Travels?',
    answer: 'Renting a bus for your tour package with Amruta Travels is easy. You can book online, contact our support team, or visit our office. We will help you select the right bus based on your tour package, group size, and destination.',
  },
  {
    question: 'What types of buses are available for tour packages?',
    answer: 'We offer a range of buses for tour packages, including 32, 35, 45, and 50 seater options. All our buses are equipped with comfortable seating, air conditioning, and ample luggage space, ensuring a comfortable journey for your entire group.',
  },
  {
    question: 'Can I book buses for multi-day tours or weekend getaways?',
    answer: 'Yes, we provide buses for both short and long tour packages, including multi-day trips, weekend getaways, and family vacations. Our buses are ideal for both day trips and extended journeys, providing comfort and safety throughout.',
  },
  {
    question: 'Are the buses suitable for both local and outstation tour packages?',
    answer: 'Yes, our buses are available for both local and outstation tour packages. Whether you are planning a city tour or a trip to a nearby destination, we ensure smooth, safe, and comfortable travel.',
  },
  {
    question: 'Are the buses well-maintained and sanitized for tours?',
    answer: 'Yes, all our buses are regularly maintained and thoroughly sanitized before every tour. We prioritize passenger safety, cleanliness, and comfort to ensure a pleasant experience for all travelers.',
  },
  {
    question: 'How much does it cost to rent a bus for a tour package?',
    answer: 'The cost of renting a bus for a tour package depends on the type of bus, duration of the tour, and the distance traveled. Contact us with your tour details for a customized and transparent quote.',
  },
  {
    question: 'Do you provide drivers with the buses for tour packages?',
    answer: 'Yes, every bus rental for tour packages comes with a professional and experienced driver. Our drivers ensure safety, punctuality, and a smooth travel experience throughout your tour.',
  },
  {
    question: 'Can I request multiple pickup and drop-off points for my tour package?',
    answer: 'Yes, we offer flexible routing with multiple pickup and drop-off points. Share your itinerary with us, and we will plan the best route to suit your travel needs.',
  },
  {
    question: 'Why choose Amruta Travels for tour package bus rentals?',
    answer: 'Amruta Travels is known for providing reliable, professional service with well-maintained buses and experienced drivers. We ensure a smooth, safe, and enjoyable travel experience for all our customers.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Rajesh Kulkarni',
    role: 'Tour Coordinator, Pune',
    text: 'We hired a 45-seater bus from Amruta Travels for a family tour package to Lonavala. The bus was spacious, clean, and on time. The driver was experienced and made sure we had a safe and enjoyable journey. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anjali Patil',
    role: 'Tourist, Pune',
    text: 'Amruta Travels provided a 50-seater bus for our 5-day tour package to Goa. The journey was comfortable, the bus was well-maintained, and the driver was very courteous. We had a fantastic trip and will definitely use their service again.',
    rating: 5,
  },
];







































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Rental for Tour Packages",
  "image": "https://bushireinpune.com/assets/images/bus-rental-for-tour-packages.jpg",
  "description": "Book a bus rental for tour packages from Pune to popular destinations like Lonavala, Lavasa, Mumbai, Nashik, Tuljapur, Pandharpur, and more. Rent AC or Non-AC buses for your outstation trips, corporate events, and pilgrimage tours like Ashtavinayak and Jyotirlinga Darshan.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5364"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "45", // Adjust based on per km or flat rate for tour bus rental
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/bus-rental-for-tour-packages"
  }
};






    return (
        <div>
<Helmet>
  <title>Call: +91 7353109555 | Bus Rental for Tour Packages | Pune to Lonavala, Mumbai, Nashik & More | Amruta Travels</title>
  <meta 
    name="description" 
    content="Rent buses for tour packages from Pune to Lonavala, Lavasa, Mumbai, Nashik, and other destinations. Choose from AC and Non-AC buses for pilgrimage tours, corporate events, and outstation trips with Amruta Travels." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/14.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Busrentalsfortourpackage;